// Description: Enum for play session types
enum ScoreFieldTypes {
  BYB_IQ = "byb_iq",
  GAMEPLAY_DURATION = "gameplay_duration",
  TOTAL_SCORE = "total_score",
  SCAN_SCORE = "scan_score",
  SCAN_RATE = "scan_rate",
  SCAN_TIMING = "scan_timing",
  CRITICAL_SCANS = "critical_scans",
  CRITICAL_SCAN_SCORE = "critical_scan_score",
  PASSES_SCORE = "passes_score",
  PASSES_MADE = "passes_made",
  PASSES_SUCCEEDED = "passes_succeeded",
  PASSES_PACKING_RATE = "passes_packing_rate",
  SHOTS_MADE = "shots_made",
  SHOTS_SUCCEEDED = "shots_succeeded",
  TACKLES_MADE = "tackles_made", // Todo change this to tackles_received in SQL table later
  TACKLES_SUCCEEDED = "tackles_succeeded", // Todo change this to tackles_delivered in SQL table later
  LABELS_MADE = "labels_made",
  LABELS_SUCCEEDED = "labels_succeeded",
  RECEIVALS_MADE = "receivals_made",
  RECEIVALS_SUCCEEDED = "receivals_succeeded",
  AWARENESS_SCORE = "awareness_score",
}

export default ScoreFieldTypes;
